import TextButtonDS from '@oberoninternal/travelbase-ds/components/action/TextButton';
import styled from 'styled-components';
import { ComponentProps, ComponentType } from 'react';

const TextButton: ComponentType<ComponentProps<typeof TextButtonDS>> = styled(TextButtonDS).attrs(props => ({
    showBorderAlways: true,
    ...props,
}))`
    > span {
        display: inline;
    }
`;

export default TextButton;
